import React, { useEffect,useState } from "react"
import Select, { components } from "react-select"

import downIcon from "../../assets/Hub_Icons/downchevron.svg"

export const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator { ...props }>
            <img
                alt="dropdown"
                src={ downIcon }
                className=""
                height={ "16px" }
                width={ "16px" }
            />
        </components.DropdownIndicator>
    )
}

export const Option = (props) => {
    return (
        <>
            <components.Option { ...props }>
                <div className="flex items-center gap-1">
                    <div className="relative cursor-pointer  select-none w-[18px] h-[18px] custom-checkbox">
                        <input
                            className="peer w-[18px] h-[18px] absolute opacity-0 z-[1]"
                            type="checkbox"
                            checked={ props.isSelected }
                            onChange={ () => null }
                        />
                        <span className={ `checkmark absolute h-[18px] w-[18px] 
                         bg-white border rounded-[4px] border-primary-50  z-[2]  
                         after:absolute after:hiddent after:content-[''] after:w-[6px] 
                         after:h-[12px] after:rotate-45  after:border-b-[2px]  
                         after:border-r-[2px] after:border-white after:left-[5px] 
                         after:top-[1px] ${props.isSelected ? "after:block !bg-primary-50" : ""}` }
                        ></span>
                    </div>
                    <label>{ props.label }</label>
                </div>
            </components.Option>
        </>
    )
}

export const customeStyles = {
    input: (styles) => ({
        ...styles,
        fontSize: "14px",
        lineHeight: "20px",
        color: "#34383F"
    }),
    indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
    option: () => ({
        color: "#34383F",
        fontSize: "14px",
        lineHeight: "20px",
        backgroundColor: "white",
        padding: "7px 12px",
        cursor: "pointer"
    }),
    singleValue: (styles) => ({
        ...styles,
        color: "#34383f"
    }),
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? "#003DA5" : "#CED0D6",
        backgroundColor: state.isFocused ? "#EDF5FF" : "white",
        borderRadius: "8px",
        boxShadow: state.isFocused && "none"
    }),
    menu: (provided) => ({
        ...provided,
        maxHeight: "260px",
        paddiing: "0",
        borderColor: "#E2E3E5",
        borderRadius: "8px",
        borderWidth: "1px",
        zIndex: "2"
    }),
    menuList: (provided) => ({
        ...provided,
        maxHeight: "260px",
        overflow: "scroll"
    })
}
const SingleSelect = (props) => {
    const {
        label,
        name,
        required,
        value,
        defaultValue,
        options,
        onChange,
        focusIndex,
        isMulti,
        disabled,
        selectedOption,
        hasSelectBoXChanged,
        renderKey

    } = props
    const [isFocused, setIsFocused] = useState(null)

    const handleFocus = (index) => {
        setIsFocused(index)
    }
    const handleBlur = () => {
        setIsFocused(null)
    }
    return (
        <div className="relative form-input  form-select">
            <div className={ "relative" }>
                <Select
                    isMulti={ isMulti }
                    name={ name }
                    defaultValue={ defaultValue }
                    options={ options }
                    styles={ customeStyles }
                    value={ !hasSelectBoXChanged ? value : "" }
                    components={ {
                        ...(isMulti && { Option }),
                        DropdownIndicator

                    } }
                    closeMenuOnSelect={ isMulti ? false : true }
                    hideSelectedOptions={ isMulti ? false : true }
                    className="basic--select"
                    classNamePrefix="select"
                    onChange={ onChange }
                    onFocus={ () => handleFocus(focusIndex) }
                    onBlur={ handleBlur }
                    placeholder=""
                    required={ required }
                    isDisabled={ disabled }
                    key={ renderKey }
                />
                <label
                    htmlFor={ name }
                    className={ `absolute flex text-sm text-secondary-50
                         peer-focus:scale-75 dark:text-secondary-50 duration-300 transform  
                         top-2 z-10 origin-[0] bg-white  px-2 peer-focus:px-2 
                         peer-focus:text-blue-600 peer-focus:dark:text-text-secondary-50  
                         peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 
                         peer-placeholder-shown:top-1/2 peer-focus:top-2  peer-focus:-translate-y-4 
                         rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 
                         cursor-text font-['Avenir'] font-normal ${isFocused == focusIndex 
                            || selectedOption || defaultValue
            ? "!-translate-y-[21px top-[-11px] leading-[14px] scale-75 testing"
            : ""}` }
                >
                    { required && <span className="text-red text-sm mr-1 flex leading-[14px]">*</span> }
                    { label }
                </label>
            </div>
        </div>
    )
}

export default SingleSelect
